import React from 'react';
import { Alert, Badge, Col, Row } from 'react-bootstrap';
import { isClient } from '../../../helpers/global';
import { clientStatusToOriginalOrderStatusMap } from '../../../helpers/constants';

function getUniqueObjectsByClientLable(dataArray) {
  const seenClientLables = new Map();
  dataArray.forEach(item => {
    if (!seenClientLables.has(item.clientLable)) {
      seenClientLables.set(item.clientLable, item);
    }
  });
  return Array.from(seenClientLables.values());
}

const AdditionalFilterGroupCheck = ({ onAllFilterCheckChange, filterValues, filterOptions, onFilterValueChange }) => {
  const role = localStorage.getItem('user-role');
  if (Object.values(filterValues).some(f => f.enabled)) {
    return (
      <>
        <Alert className="px-2 py-1 relative" variant="dark">
          <Row className="px-2">
            {filterOptions.map(option => (
              <>
                {filterValues[option.key].enabled && option.options.length > 0 && (
                  <Col className="rounded p-2 m-1 bg-white">
                    <div>
                      <div className="d-flex align-items-center">
                        <input
                          type="checkbox"
                          className="d-inline mr-2"
                          style={{ height: 12, width: 12 }}
                          onChange={() => onAllFilterCheckChange(option.key)}
                          checked={option.options.every(o => filterValues[option.key].values.includes(o.value))}
                        />
                        <label className="xsmallFont mb-0">
                          <b>Select All</b>
                          <span className="xsmallFont mx-2">
                            <b>{`(${option.key})`}</b>
                          </span>
                        </label>
                      </div>
                      <hr className="mt-1 mb-2" />
                      <div className="d-flex flex-wrap">
                        {isClient(role)
                          ? getUniqueObjectsByClientLable(option.options).map(o => {
                              const orderStatus = clientStatusToOriginalOrderStatusMap[o.clientLable] || o.value;
                              return (
                                <Badge
                                  style={{ fontSize: 12 }}
                                  variant={
                                    filterValues[option.key].values.some(v => orderStatus.includes(v))
                                      ? 'primary'
                                      : 'light'
                                  }
                                  className={`text-dark hover hover-text-dark  px-2 py-1 ml-1 mb-1 border border-dark`}
                                  onClick={() => onFilterValueChange(option.key, orderStatus)}
                                >
                                  {o.clientLable}
                                </Badge>
                              );
                            })
                          : // Accurate side badge
                            option.options.map(o => {
                              return (
                                <Badge
                                  style={{ fontSize: 12 }}
                                  variant={filterValues[option.key].values.includes(o.value) ? 'primary' : 'light'}
                                  className={`text-dark hover hover-text-dark  px-2 py-1 ml-1 mb-1 border border-dark`}
                                  onClick={() => onFilterValueChange(option.key, o.value)}
                                >
                                  {o.value}
                                </Badge>
                              );
                            })}
                      </div>
                    </div>
                  </Col>
                )}
              </>
            ))}
          </Row>
        </Alert>
      </>
    );
  }
  return null;
};

export default AdditionalFilterGroupCheck;
